module.exports = __webpack_public_path__ + "img/location.05e3ab33.svg";